import { render, staticRenderFns } from "./teachingInquiry.vue?vue&type=template&id=4bbbdb6e&scoped=true&"
import script from "./teachingInquiry.vue?vue&type=script&lang=js&"
export * from "./teachingInquiry.vue?vue&type=script&lang=js&"
import style0 from "./teachingInquiry.vue?vue&type=style&index=0&id=4bbbdb6e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbbdb6e",
  null
  
)

export default component.exports